export default __webpack_public_path__ + "atomic/_patterns/02-molecules/node-teaser-brief/_node-teaser-brief.twig";